import React, {useState} from 'react'

import POPinsToggle from "./POPinsToggle";



const TitleAndToggle = ({ defaultFilters, updateEvents }) => {
  const [selectedFilters, setSelectedFilters] = useState({})

  const onFilter = (filterId, obj) => {
    const newFilters = { ...selectedFilters, [filterId]: obj }
    setSelectedFilters(newFilters)
    updateEvents(newFilters /*, sortBy*/)
  }

  return (
    <div className="row no-gutters title_search">
      <div className="title_wrapper">
        <h2 className="heading">My Activity</h2>
      </div>
      <POPinsToggle defaultFilters={defaultFilters} onClick={onFilter} />
    </div>
  )
}

export default TitleAndToggle